import { useEffect, useRef, useState, useContext } from "react";
import { UrlContext } from "../contexts/UrlContext";

export default function useActivityTracker(timeoutMs, getToken) {
  const { API_URL } = useContext(UrlContext);
  const [isOnline, setIsOnline] = useState(true);
  const timerRef = useRef(null);
  const lastStatusRef = useRef(true);
  const token = getToken();

  const updateStatus = async (status) => {
    if (status === lastStatusRef.current) return;
    lastStatusRef.current = status;
    setIsOnline(status);
    try {
      await fetch(`${API_URL}consultant-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ isOnline: status}),
      });
    } catch (err) {
      console.error("Status update failed:", err);
    }
  };

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    updateStatus(true);
    timerRef.current = setTimeout(() => updateStatus(false), timeoutMs);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    updateStatus(true);
    resetTimer(); // initialize timer

    return () => {
      clearTimeout(timerRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [timeoutMs, token]);

  return isOnline;
}
